import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.listPODisclaimerLabels.pODisclaimerLabelTable`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Purchase order disclaimer labels',
  },
  columnLabelDescription: {
    id: `${scope}.columnLabelDescription`,
    defaultMessage: 'Label description',
  },
  columnLabelContent: {
    id: `${scope}.columnLabelContent`,
    defaultMessage: 'Label content (displays in PO PDF templates)',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no disclaimers',
  },
  setDefaultButtonLabel: {
    id: `${scope}.setDefaultButtonLabel`,
    defaultMessage: 'Set {description} as default',
  },
  removeDefaultButtonLabel: {
    id: `${scope}.removeDefaultButtonLabel`,
    defaultMessage: 'Remove {description} as default',
  },
  setDefaultButtonTitle: {
    id: `${scope}.setDefaultButtonTitle`,
    defaultMessage: 'Set as default',
  },
  deleteLabelButtonLabel: {
    id: `${scope}.deleteLabelButtonLabel`,
    defaultMessage: 'Delete label {description}',
  },
  deleteLabelButtonTitle: {
    id: `${scope}.deleteLabelButtonTitle`,
    defaultMessage: 'Delete label',
  },
})
